import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";

export default function BankTransfer() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const token = params.get("t");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      const q = token ? `?t=${token}` : "";
      api.get(`/orders/${orderId}${q}`).then((r) => setOrder(r.data));
    }
  }, [orderId, token]);

  if (!order) return <div className="container-kv pt-32 pb-20">Loading...</div>;

  const ref = `KV-${order.id.slice(0, 8).toUpperCase()}`;

  return (
    <div className="container-kv pt-28 pb-20" data-testid="bank-transfer-page">
      <div className="max-w-2xl mx-auto card-kv">
        <div className="overline mb-3">Bank Transfer</div>
        <h1 className="font-serif text-3xl mb-4">Complete your payment</h1>
        <p className="text-[#A8A5A1] mb-8 text-sm">
          Transfer the total below to the account details. Use the reference code so we can match your payment. Your order ships as soon as funds clear (1–2 business days).
        </p>

        <div className="border border-white/10 p-6 space-y-3 font-mono text-sm">
          <Row label="Bank" value="BANK CENTRAL ASIA" />
          <Row label="Account Name" value="Benedictus Kevin Fernandez" />
          <Row label="Account No." value="0660995561" />
          <Row label="Kode Swift" value="CENAIDJA" />
          <Row label="Amount" value={`$${order.total.toFixed(2)} USD`} />
          <Row label="Reference" value={ref} highlight />
        </div>

        <div className="mt-8 space-y-3 text-sm text-[#A8A5A1]">
          <p>After transferring, message us on WhatsApp or iMessage with your reference <span className="text-[#C8A97E] font-mono">{ref}</span> for faster processing.</p>
        </div>

        <div className="mt-8 flex gap-3">
          <Link to="/shop" className="btn-ghost">Continue Shopping</Link>
          <Link to="/account" className="btn-gold flex-1">View My Orders</Link>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div className="flex justify-between gap-3">
      <span className="text-[#75726D]">{label}</span>
      <span className={highlight ? "text-[#C8A97E]" : ""}>{value}</span>
    </div>
  );
}
